var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33325 4L5.94193 6.61131C7.64098 7.574 8.35885 7.574 10.0579 6.61131L14.6666 4",
    stroke: "#626F86",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.34377 8.98365C1.38735 11.0274 1.40914 12.0492 2.16323 12.8062C2.91731 13.5631 3.96681 13.5895 6.06581 13.6422C7.35945 13.6747 8.64039 13.6747 9.93405 13.6422C12.0331 13.5895 13.0825 13.5631 13.8367 12.8062C14.5907 12.0492 14.6125 11.0274 14.6561 8.98365C14.6701 8.32652 14.6701 7.67332 14.6561 7.01619C14.6125 4.97249 14.5907 3.95065 13.8367 3.19369C13.0825 2.43674 12.0331 2.41037 9.93405 2.35763C8.64039 2.32513 7.35945 2.32513 6.0658 2.35763C3.9668 2.41036 2.91731 2.43673 2.16322 3.19369C1.40913 3.95064 1.38735 4.97249 1.34376 7.01619C1.32975 7.67332 1.32975 8.32652 1.34377 8.98365Z",
    stroke: "#626F86",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.4153b23c98d1b2419793ce978a43c4d3.svg";
export { ForwardRef as ReactComponent };